export default __webpack_public_path__ + "bold-text-option.png";